import React from 'react'
import { useFocusedErrorProps } from '@linqpal/common-frontend/src/hooks'
import { validators } from '@linqpal/models'
import CommonInput from '../../ui/atoms/builder-2.0/CommonInput'
import { KeyboardType } from '@linqpal/models/src/dictionaries'

export default function EmailInput({
  value,
  onChangeText,
  editable = true,
  onSubmitEditing,
  hidden,
  placeholder,
  autoFocus,
  testID = 'email',
  ...props
}) {
  const errorProps = useFocusedErrorProps(
    value && !validators.validateEmail(value) ? 'Invalid Email ' : '',
  )
  return (
    <CommonInput
      testID={testID}
      name="email"
      value={value}
      {...errorProps}
      autoFocus={autoFocus}
      onChangeText={onChangeText}
      editable={editable}
      placeholder={placeholder || 'example@example.com'}
      onSubmitEditing={onSubmitEditing}
      autoComplete="email"
      keyboardType={KeyboardType.EmailAddress}
      inputOuterStyle={hidden ? { display: 'none' } : undefined}
      {...props}
    />
  )
}
